// extracted by mini-css-extract-plugin
module.exports = {"contactItem":"index-module_contactItem_21dIf"};